import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const getAllUsers_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.USER}/users?${params}`
	);
	return response.data;
};

export const getAllReferrals = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.USER}/referred-users?${params}`
	);
	return response.data;
};

export const getUserDetails_api = async (id) => {
	if (id && id != "add") {
		const response = await authenticatedApi.get(
			`${MICROSERVICE_CONFIG.USER}/users/${id}`
		);
		return response.data;
	}
};

export const updateUser_api = async ({ id, fileData }) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.USER}/users/${id}`,
		fileData,
		{ headers: { "Content-Type": "multipart/form-data" } }
	);
	return response.data;
};

export const blockUser_api = async (id) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.AUTH}/admin/block/user/${id}`
	);
	return response.data;
};

export const unblockUser_api = async (id) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.AUTH}/admin/unblock/user/${id}`
	);
	return response.data;
};

export const downloadUsers_api = async (params) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.SUPERADMIN_BFF}/download/users`,
		params
	);
	return response.data;
};

export const getOrderByUser_api = async (id) => {
	if (id) {
		const response = await authenticatedApi.get(
			`${MICROSERVICE_CONFIG.ACCOUNTING}/orders/user/${id}`
		);
		return response.data;
	}
};

export const getReferredUsers = async (payload) => {
	const { userId, queryParams } = payload;
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.USER}/referred-users/${userId}?${queryParams}`
	);
	return response?.data;
};

export const getNotOnboardedUsers = async (payload) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.AUTH}/guest-users?${payload}`
	);
	return response?.data;
};

export const saveUserInfo = async (payload) => {
	const { userId, body } = payload;
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.USER}/profile/${userId}`,
		body,
		{
			headers: {
				"Content-Type": "multipart/form-data",
			},
		}
	);
	return response?.data;
};

export const updateUserCredentials = async (payload) => {
	const { userId, body, role } = payload;
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.AUTH}/admin/profile/${userId}?role=${role}`,
		body
	);
	return response.data;
};
